import React, { useEffect, useState, useContext, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { notificationActions } from '../../../actions/notification.actions.js';
import { Button, Dropdown, Form, Spinner } from 'react-bootstrap';
import { user_profileActions, workspace_userActions } from '../../../actions';
import { Link } from 'react-router-dom';
import ShowIcon from '../../../images/icons/show.svg';
import HideIcon from '../../../images/icons/hide.svg';
import DotsIcon from '../../../images/dots.png';
import { UserAvatar, ReminderAvatar } from '../../../components';
import { adminBaseURL } from '../../../utils/commonUtils';
import { renderNameAndSummary, renderDueNotificationSummary } from '../../../utils/';
import { TopbarContext } from '../../../contexts/TopbarContext';
import { buildFormDataFromObject } from '../../../utils/commonUtils';
import { useCallback } from 'react';
import { NotificationAllReadChecker } from '../../../components/notifications/NotificationAllReadChecker.js';
import { ContainerSpinner } from '../../../components/ContainerSpinner.js';
import FlatThreeDot from '../../../components/icons/FlatThreeDot.js';
import { groupByDay } from '../../../helpers/groupByDay.js';
import { dayFormatter } from '../../../helpers/dayFormatter.js';

function NotificationsDropdown(props) {
  const dispatch = useDispatch();
  const workspaceBaseUrl = adminBaseURL("workspaces");
  const {
    current_organization,
    notifications,
    handleHideNotificationsDropdown,
    can_access_content,
    can_access_edit_title,
    handleModalCloseNotification,
    notification_load,
    showNotificationsDropdown,
    deleted_notification,
    updated_notification,
    notification_loading
  } = props
  const [ filter_notifications, set_filter_notifications] = useState(notifications ? notifications : []);
  const [ filter_activites, set_filter_activites] = useState(false);
  const work_space = useSelector(state => state.work_space.currentWorkSpace);
  const [show_option_dropdown, set_show_option_dropdown] = useState(false);
  const { is_home_page, enable_notification_ring, setEnableNotificationRing } = useContext(TopbarContext);

  useEffect(() => {
    if(showNotificationsDropdown){
      loadNotifications(null)
    }
  }, [showNotificationsDropdown, filter_activites]);

  useEffect(() => {
    if(deleted_notification){
      set_filter_notifications(
        prevState => prevState.filter(notif => {
          return notif.id !== deleted_notification.id
        })
      )
    }
  }, [deleted_notification]);

  useEffect(() => {
    if(updated_notification){
      set_filter_notifications(
        prevState => prevState.map(notif => {
          return notif.id === updated_notification.id ? updated_notification : notif
        })
      )
    }
  }, [updated_notification]);

  useEffect(() => {
    if (notification_load && filter_activites) {
      set_filter_notifications(
        prevState => prevState.map(notif => {
          return notif.id === notification_load.id ? notification_load : notif
        })
        .filter(item => !item.is_read)
      )
    }

  }, [notification_load, filter_activites]);

  const loadNotifications = (lastNotificationId) => {
    let onSuccess = (data) => {
      set_filter_notifications(data.data)
    }
    const isUserRole = localStorage.getItem('user_role')
    const filter_type = 'a_week';

    dispatch(notificationActions.getPage({only_unread: filter_activites, lastNotificationId, onSuccess, filter_type}))
  }

  const handleRead = (notificationId) => {
    dispatch(notificationActions.read(notificationId));
  }

  const handleUnRead = (notificationId) => {
    dispatch(notificationActions.unRead(notificationId));
  }

  const hideNotificationPopup = () => {
    props.handleHideNotificationsDropdown()
  }

  const handleReadAll = () => {
    dispatch(notificationActions.readAll(() => loadNotifications(null)));
    set_show_option_dropdown(false);
  }

  const onSwitchNotificaton = () => {
    set_filter_activites(!filter_activites)
  }

  const contentClickHandler = (e) => {
    const targetLink = e.target.closest('a');
    if(!targetLink) return;
    e.preventDefault();
    var content_id = targetLink.getAttribute("data-contentId")
    var workspace_id = targetLink.getAttribute("data-workspaceId")
    var organization_id = targetLink.getAttribute("data-organizationId")
    var content_name = targetLink.getAttribute("data-contentName")
    var comment_id = targetLink.getAttribute("data-commentId")
    var internal = targetLink.getAttribute("data-internal")
    var cg_id = targetLink.getAttribute("data-commentCgId")

    handleModalCloseNotification(content_id, workspace_id, comment_id, internal, cg_id, work_space?.updated_at, can_access_content, can_access_edit_title)
  };

  const optionsClickHandler = (e) => {
    if (show_option_dropdown){
      set_show_option_dropdown(false)
    } else {
      set_show_option_dropdown(true)
    }
  }

  const workspaceClickHandler = (e, organization_id, workspace_id) =>{
    e.stopPropagation();

    window.location = `/organizations/${organization_id}${workspaceBaseUrl}/${workspace_id}/list`

    return true;
  }

  const viewAllNotificationHandler = () => {
    handleHideNotificationsDropdown()

    window.location = `/`
  }

  const renderSummaryHtml = (data) => {
    const bold_name = true;
    const one_line = true;

    if(data?.notification_type === 'due_reminder'){
      return renderDueNotificationSummary(data)
    }

    if(data?.notification_type === 'removed_from_workspace' &&
      data?.actor?.user_id === data?.user_id
    ){
      return data.summary
    }

    return renderNameAndSummary(data?.actor?.name, data?.summary, bold_name, one_line);
  }

  const handleToggleNotificationRing = () => {
    let formData = new FormData();

    buildFormDataFromObject(formData, {enable_notification_ring: !enable_notification_ring}, "user");

    const success_callback = (res) => {
      setEnableNotificationRing(prevState => res.enable_notification_ring)
    }
    
    dispatch(user_profileActions.updateNotificationRingSetting(formData, success_callback));
  }

  const handleAcceptInvitation = (e, data) => {
    e.preventDefault();
    e.stopPropagation();

    const {
      workspace_id, 
      id: notification_id, 
      resource_id:id 
    } = data;

    dispatch(workspace_userActions.acceptInvitation(workspace_id, id, notification_id))
  }

  const handleDeclineInvitation = (e, data) => {
    e.preventDefault();

    const {
      workspace_id, 
      id: notification_id, 
      resource_id:id 
    } = data;

    dispatch(workspace_userActions.declineInvitation(workspace_id, id, notification_id))
  }

  const renderInvitationButton = useCallback((data) => {
    if(data.notification_type !== "new_workspace_invite" ) return;

    const { status } = data.parsed_notification_data;

    if (status === 'accepted') {
      return (
        <div className="d-flex" style={{ marginTop: '6px', marginBottom: '6px' }}>
          <Button className='disabled'>Accepted</Button>
        </div>
      )
    } else if ( status === 'declined' ) {
      return (
        <div className="d-flex" style={{ marginTop: '6px', marginBottom: '6px' }}>
          <Button variant='secondary' className='disabled'>Declined</Button>
        </div>
      )
    } else {
      return (
        <div className="d-flex" style={{ marginTop: '6px', marginBottom: '6px' }}>
          <Button className='me-3' onClick={(e) => handleAcceptInvitation(e, data)}>Accept</Button>
          <Button variant='secondary' className='' onClick={(e) => handleDeclineInvitation(e, data)}>Decline</Button>
        </div>
      )
    }
  }, [])

  const grouped_notifications = useMemo(() => groupByDay(filter_notifications), [filter_notifications]);

  return (
    <div>
      <div className={`notifications-dropdown box-lg-shadow ${ is_home_page && 'full_dropdown' }`}>
        <div className="notifications-dropdown__header d-flex align-items-center justify-content-between">
          <h5 className="mb-0 font-weight-500">Notifications</h5>
          <div className="d-flex align-items-center notification_options">
            <span
              onClick={onSwitchNotificaton}
              className="cursor-pointer btn-read_switch d-flex align-items-center"
            >
              {filter_activites ?
                  'Show All' :
                  'Hide Read'
              }
              
            </span>
            <Dropdown className="notification_dropdown" show={show_option_dropdown} onToggle={() => optionsClickHandler()}>
              <Dropdown.Toggle id="dropdown-basic" className="p-0 d-flex align-items-center justify-content-center" >
                <FlatThreeDot height={4} width={18}/>
              </Dropdown.Toggle>
              <Dropdown.Menu style={{right: "auto"}} className="box-shadow">
                <ul className="notification_ul">
                  <li ><Link className="cursor-pointer" to="#" onClick={viewAllNotificationHandler}>View All</Link></li>
                  <li ><a className="cursor-pointer" href="#" onClick={handleReadAll}> Mark all as read </a></li>
                  <li >
                    <div
                      className='cursor-pointer'
                      onClick={handleToggleNotificationRing}
                    >
                      Sound { enable_notification_ring ? 'On' : 'Off'}
                    </div>
                  </li>
                </ul>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className="notifications-dropdown__content position-relative">
          {
            notification_loading &&
              <ContainerSpinner />
          }

          { grouped_notifications ?
            Object.entries(grouped_notifications).map(([day, notifications], index) => (
              <div key={day}>
                <div className="notification__day-label" data-label={dayFormatter(day)}>
                  {dayFormatter(day)}
                </div>
                {
                  notifications.map((data, idx) => (
                    <div
                      key={'notification_dropdown_'+data.id}
                      onClick={() => data.is_read ? handleUnRead(data.id) : handleRead(data.id)}
                    >
                      <div
                        className={data.is_read ? 'notifications read_message' : 'notifications unread_message'}
                        onClick={contentClickHandler}
                      >
                        <div className="d-flex w-100 notification-info_container">
                          {
                            (data?.notification_type === 'due_reminder' || data?.notification_type === 'past_due_reminder') ?
                              <div className="notification__image-wrapper">
                                <ReminderAvatar due_date={data?.due_date} past_due={data?.notification_type === 'past_due_reminder'}/>
                              </div>
                            :
                              (data?.actor?.icon || data?.actor?.name_initials) &&
                                <div className="notification__image-wrapper">
                                  <UserAvatar
                                    icon={ data.actor.icon }
                                    name={ data.actor.name }
                                    name_initials={ data.actor.name_initials }
                                    size="30"
                                    user_id={data.actor.user_id}
                                    workspace_id={ data.workspace_id }
                                    organization_id={ data.organization_id }
                                    openUserSummary={true}
                                  />
                                </div>

                          }
                          <div className="notification-description_container">
                            <div>
                              <div className="notification__description" dangerouslySetInnerHTML={{__html: renderSummaryHtml(data)}} />
                              {
                                renderInvitationButton(data)
                              }
                              <div className="notifications-dropdown__notification-timestamp" title={ data.created_at_readable }>
                                <span className="mr-3">
                                  { data.created_at_time_from_now }
                                </span>
                                <span className="workspace_link" onClick={(e) => workspaceClickHandler(e, data.organization_id, data.workspace_id)}>
                                  { data.workspace_name }
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                }
              </div>
            )) : null
          }

          {
            filter_notifications.length > 0 &&
              <div className='d-grid w-100'>
                <Link className="py-3 py-lg-2 btn-white btn btn-sm border-0" to="#" onClick={viewAllNotificationHandler}>View All</Link>
              </div>
          }

          {
            !notification_loading && filter_activites &&
              <div className={`w-100 text-center notifications-dropdown__content__all-clear ${filter_notifications?.length > 0 ? 'py-1' : 'py-5'} `}>
                <NotificationAllReadChecker notifications={filter_notifications}/>
              </div>
          }
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    current_organization: state.organization.current_organization,
    loading: state.workspaceUser.loading,
    notifications: state.notification.notifications,
    updated_notification: state.notification.updated_notification,
    deleted_notification: state.notification.deleted_notification,
    enable_notification_ring: state.notification.enable_notification_ring,
    notification_load: state.notification.notification_load,
    notification_loading: state.notification.notification_loading,
    can_access_content: state.notification.can_access_content,
    can_access_edit_title: state.notification.can_access_edit_title
  };
};

export default connect(mapStateToProps, { notificationActions })(NotificationsDropdown);
